import { configureIguazuREST } from 'iguazu-rest';
import cbisAuthorization from './cbisAuthorization/cbisAuthorization';
import supplierEnrollmentResource from './simpleSupplierEnrollment/supplierEnrollmentResource';

import { ReduxState } from '../types';

const configureIguazuResources = () => {
  configureIguazuREST({
    getToState: (state: ReduxState) =>
      state.getIn(['modules', 'commercial-experience-root', 'resources']),
    resources: {
      cbisAuthorization,
      supplierEnrollmentResource,
    },
  });
};

configureIguazuResources();

export default configureIguazuResources;
